import { useLanguage } from "../i18n/LanguageContext";
import { useState, useRef, useEffect } from "react";

const FlagES = () => (
  <svg viewBox="0 0 640 480" className="w-5 h-3.5 rounded-sm flex-shrink-0">
    <rect width="640" height="480" fill="#c60b1e"/>
    <rect width="640" height="240" y="120" fill="#ffc400"/>
  </svg>
);

const FlagGB = () => (
  <svg viewBox="0 0 640 480" className="w-5 h-3.5 rounded-sm flex-shrink-0">
    <rect width="640" height="480" fill="#012169"/>
    <path d="M75 0l244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z" fill="#fff"/>
    <path d="M424 281l216 159v40L369 281h55zm-184 20l6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z" fill="#C8102E"/>
    <path d="M241 0v480h160V0H241zM0 160v160h640V160H0z" fill="#fff"/>
    <path d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z" fill="#C8102E"/>
  </svg>
);

const FlagDE = () => (
  <svg viewBox="0 0 640 480" className="w-5 h-3.5 rounded-sm flex-shrink-0">
    <rect width="640" height="160" fill="#000"/>
    <rect width="640" height="160" y="160" fill="#D00"/>
    <rect width="640" height="160" y="320" fill="#FFCE00"/>
  </svg>
);

const FlagIT = () => (
  <svg viewBox="0 0 640 480" className="w-5 h-3.5 rounded-sm flex-shrink-0">
    <rect width="213.3" height="480" fill="#009246"/>
    <rect width="213.3" height="480" x="213.3" fill="#fff"/>
    <rect width="213.3" height="480" x="426.6" fill="#ce2b37"/>
  </svg>
);

const flagComponents = { es: FlagES, en: FlagGB, de: FlagDE, it: FlagIT };
const langLabels = { es: "ES", en: "EN", de: "DE", it: "IT" };

export const LanguageSelector = ({ variant = "light" }) => {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClose = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClose);
    document.addEventListener("touchstart", handleClose);
    return () => {
      document.removeEventListener("mousedown", handleClose);
      document.removeEventListener("touchstart", handleClose);
    };
  }, []);

  const isDark = variant === "dark";
  const languages = ["es", "en", "de", "it"];
  const CurrentFlag = flagComponents[lang];

  return (
    <div className="relative" ref={ref} style={{zIndex: 9999}} data-testid="language-selector">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 px-2 py-1.5 rounded-full text-sm font-medium transition-all min-w-[36px] min-h-[36px] justify-center ${
          isDark
            ? "text-white/60 hover:text-white hover:bg-white/10"
            : "text-[#6B7280] hover:text-[#111111] hover:bg-black/5"
        }`}
        data-testid="language-selector-btn"
        type="button"
      >
        <CurrentFlag />
        <span className="text-xs font-bold hidden sm:inline">{langLabels[lang]}</span>
      </button>

      {open && (
        <div className={`absolute right-0 top-full mt-2 w-44 rounded-xl shadow-xl border overflow-hidden ${
          isDark
            ? "bg-[#1a1a2e] border-white/10"
            : "bg-white border-[#E5E5EA]"
        }`} style={{zIndex: 99999}} data-testid="language-dropdown">
          {languages.map((code) => {
            const Flag = flagComponents[code];
            return (
              <button
                key={code}
                onClick={() => { setLang(code); setOpen(false); }}
                type="button"
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm transition-all ${
                  lang === code
                    ? (isDark ? "bg-white/10 text-white" : "bg-[#002FA7]/5 text-[#002FA7]")
                    : (isDark ? "text-white/70 hover:bg-white/5 hover:text-white" : "text-[#333] hover:bg-[#F5F5F7]")
                }`}
                data-testid={`lang-option-${code}`}
              >
                <Flag />
                <span className="flex-1 text-left">{t(`lang_${code}`)}</span>
                {lang === code && <span className="text-xs opacity-60">&#10003;</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
